<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-serach-settings':state.visible.visibleNoteSearchMenu},
    {'is-visible-menu':state.visible.visibleMenu},
    {'is-visible-menu-left':state.visible.visibleMenuLeft},
    {'is-focused-input':state.visible.isFocusInput}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visible.visibleMenu"
      @searchByKeyword="action.preSearch"
      @closeMenu="state.visible.visibleMenu = false"
    />

    <!-- 詳細検索 -->
    <transition name="popup">
      <SPQASearchDetail
        v-if="state.visible.visibleSearchDetail"
        :startLoading="state.visible.visibleSearchDetail"
        :parentName="'SPBookList'"
        @searchDetail="action.searchDetail"
        @closeSearchDetail="state.visible.visibleSearchDetail = false"
      />
    </transition>

    <!-- 左ナビ -->
    <div id="menu-left" class="menu-left">
      <ul class="menu-left-list">
        <li v-if="narrow.tags.length > 0 || narrow.filterTagsExcludeTag.length > 0" class="menu-left-list-item">
          <span class="menu-left-list-item-label"
            @click="state.visible.visibleAddTagFromPast = true;"
          >タグの絞り込み条件を設定する</span>
        </li>
        <li v-if="narrow.userLists.length > 0" class="menu-left-list-item">
          <span class="menu-left-list-item-label"
            @click="state.visible.visibleNoteSearchExtract = true;"
          >ノートの作成者で絞り込む</span>
        </li>
        <li class="menu-left-list-item ga-note-mode-edit">
          <span class="menu-left-list-item-label ga-note-mode-edit"
            @click="action.newNote">
            ノートの新規作成
          </span>
        </li>
      </ul>
      <div class="menu-left-close"
        @click="state.visible.visibleMenuLeft = false"
      >
        <span class="icn-wrap"><FontawesomeIcon :icon="['fal', 'times']" class="icn" /></span>
      </div>
    </div>

    <!-- 表示設定 -->
    <transition name="popup">
      <SPNoteSearchDisplaySetting
        v-if="state.visible.visibleNoteSearchDisplaySetting"
        @closeNoteSearchDisplaySettings="state.visible.visibleNoteSearchDisplaySetting = false"
      />
    </transition>

    <!-- 並び順設定 -->
    <transition name="popup">
      <SPNoteSearcOrderSetting
        v-if="state.visible.visibleNoteOrderSetting"
        @close="state.visible.visibleNoteOrderSetting = false"
      />
    </transition>

    <!-- 絞り込み設定 -->
    <transition name="popup">
      <SPNoteSearchExtract
        v-if="state.visible.visibleNoteSearchExtract"
        :narrow="narrow"
        @closeNoteSearchExtract="state.visible.visibleNoteSearchExtract = false"
        @submitNoteSearchExtract="state.visible.visibleMenuLeft = false"
      />
    </transition>

    <!-- タグ絞り込み設定 -->
    <transition name="popup">
      <SPNoteAddTagFromPast
        v-if="state.visible.visibleAddTagFromPast"
        :narrow="narrow"
        @closeNoteAddTagFromPast="state.visible.visibleAddTagFromPast = false"
        @submitNoteAddTagFromPast="state.visible.visibleMenuLeft = false"
      />
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-1"
          :class="{'is-active': state.visible.visibleNoteSearchMenu}"
          @click="state.visible.visibleNoteSearchMenu = !state.visible.visibleNoteSearchMenu"
        >
          <FontawesomeIcon :icon="['fas','search']" class="icn icn-closed"/>
          <FontawesomeIcon :icon="['fas','times']" class="icn icn-opened"/>
        </div>
        <div role="button" class="menu-btn-2"
          @click="state.visible.visibleMenu = true;state.visible.visibleNoteSearchMenu = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        @click="state.visible.visibleMenuLeft = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>

      <!-- 検索ウインドウ -->
      <SPSearchUI 
        :screenType="'note'"
        :isAlertShown="false"
        :isSearchExecutedAtSameScreen="true"
        @search="action.search"
        @close="state.visible.visibleNoteSearchMenu = false"
        @searchResetOptions="action.reset"
        @openSearchDetail="state.visible.visibleSearchDetail = true;state.visible.visibleNoteSearchMenu = false"
        @handleFocusOutInput="state.visible.isFocusInput = false"
        @handleFocusInput="state.visible.isFocusInput = true"
      />

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>ノート</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div v-if="state.isSearch" class="main-heading-row main-heading-result">
              <div class="main-heading-result-num">{{state.noteCount}}件</div>
            </div>
            <div class="main-heading-row main-heading-menu column">
              <div class="main-heading-menu-item column-item col-8">
                <div role="button" class="main-heading-menu-link"
                  @click="state.visible.visibleNoteOrderSetting = true"
                >
                  並び順 - {{state.orderDisplay}}
                  <FontawesomeIcon v-if="state.visible.visibleNoteOrderSetting" :icon="['fas','angle-up']" size="lg" class="icn up" />
                  <FontawesomeIcon v-else :icon="['fas','angle-down']" size="lg" class="icn down" />
                </div>
              </div>
              <div class="main-heading-menu-item column-item col-4">
                <div role="button" class="main-heading-menu-link"
                  @click="state.visible.visibleNoteSearchDisplaySetting = true"
                >
                  表示設定
                </div>
              </div>
            </div>
          </div>
          <div class="main-container"
            @scroll="handleScroll($event); action.scroll($event)"
            >
            <ul v-if="data.noteLists.length > 0 || !note.complete" class="list-result">
              <li v-for="noteList in data.noteLists" :key="'noteList_' + noteList.id" class="list-result-item">
                <div class="list-result-item-main">
                  <div class="list-result-title">
                    <router-link :to="'/sp/note-edit/' + noteList.id">
                      <template v-for="(string, stIndex) in noteList.title.split(regExp)">
                        <em v-if="keywordSplit.includes(string.toLowerCase())" class="matched" :key="noteList.id + 'title_' + stIndex">{{string}}</em>
                      <template v-else>{{string}}</template>
                      </template>
                    </router-link>
                  </div>
                  <p v-if="note.display.content" class="list-result-text txt-newline">
                    <template v-for="(string, stIndex) in noteList.except.split(regExp)">
                      <em v-if="keywordSplit.includes(string.toLowerCase()) && string" class="matched" :key="noteList.id + 'text_' + stIndex">{{string}}</em>
                      <template v-else>{{string}}</template>
                    </template>
                  </p>
                  <div v-if="note.display.created || note.display.modified" class="list-result-note">
                    <span v-if="note.display.created" class="list-result-sup">作成日：{{formatDate(noteList.created)}}</span>
                    <span v-if="note.display.modified" class="list-result-sup">更新日：{{formatDate(noteList.modified)}}<template v-if="noteList.modified_user_name">（更新者：{{noteList.modified_user_name}}）</template></span>
                  </div>
                  <div v-if="note.display.user" class="list-result-auther">
                    <span class="text">
                      <span class="name">作成者：{{noteList.create_user_name}}</span>

                      <div class="list-result-icn">
                        <span v-if="noteList.user_file_id > 0" class="wrap" :style="[noteList.image && {backgroundImage : 'url(' + noteList.image + ')'}]"></span>
                        <span v-else class="wrap no-image">{{noteList.create_user_name.slice(0, 1)}}</span>
                        <span class="list-result-auth" v-if="noteList.share_classification === 21">閲覧</span>
                        <span class="list-result-auth edit" v-else-if="noteList.share_classification === 22">編集</span>
                      </div>
                    </span>
                  </div>
                </div>
              </li>
              <li v-if="!note.complete" ref="LoadingBlock" style="padding-top: 50%;">
                <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt20 mb20 icn fa-spin" />
              </li>
            </ul>
            <ul v-else>
              <li class="list-result-item">
                <div class="list-result-item-main">
                ノートがありません。<br>ノートは「ノートの新規作成」から作成いただけます。
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import SPSearchUI from '@/components/sp/partial/SPSearchUI.vue'
import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPQASearchDetail from '@/components/sp/popup/SPQASearchDetail.vue'
import SPNoteSearcOrderSetting from '@/components/sp/popup/SPNoteSearcOrderSetting.vue'
import SPNoteSearchDisplaySetting from '@/components/sp/popup/SPNoteSearchDisplaySetting.vue'
import SPNoteSearchExtract from '@/components/sp/popup/SPNoteSearchExtract.vue'
import SPNoteAddTagFromPast from '@/components/sp/popup/SPNoteAddTagFromPast.vue'
import SPBasicToast from '@/components/sp/popup/SPBasicToast.vue'

import { NoteList } from '@/logic/note/NoteList'

export default defineComponent({
  beforeRouteLeave (to, from, next) {
    // 遷移の際にストアをクリアする
    // if (to.name !== 'SPNoteEdit') {
    //   store.dispatch('note/resetAllState')
    // }
    next()
  },
  components: {
    SPSearchUI,
    SPMenu,
    SPQASearchDetail,
    SPNoteSearcOrderSetting,
    SPNoteSearchDisplaySetting,
    SPNoteSearchExtract,
    SPNoteAddTagFromPast,
    SPBasicToast
  },
  setup (props, context) {
    const store = context.root.$store
    const { note } = store.state
   
    return {
      ...NoteList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
  }
}
.menu-btn {
  &-1 {
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}

.list-result {
  &-title {
    padding-right: 0;
  }
  &-icn {
    position: relative;
    padding-right: 30px;
  }
  &-auth {
    padding: 4px 6px;
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 10px;
    border: 1px solid #EEEEEE;
    color: #646464;
    line-height: 1;
    background-color: #EEEEEE;
    border-radius: 2px;
    z-index: 10;
    &.edit {
      background-color: #80889B;
      color: #FFFFFF;
    }
  }
  &-note {
    .list-result-sup {
      display: block;
      margin: 0 !important;
    }
  }
}

.is-visible-serach-settings {
  .menu-btn {
    // transform: translate3d(0,-128px,0);
    transform: translate3d(0,-271px,0);
    &-1 {
      .icn {
        transition: all .2s ease;
      }
      .icn-opened {
        opacity: 1;
      }
      .icn-closed {
        opacity: 0;
      }
    }
  }
  .search-settings {
    transform: translate3d(0,0,0);
    box-shadow: 0 -8px 8px rgba(0,0,0,.16);
  }
}
</style>
